<!-- Based on the example from https://videojs.com/guides/vue/ -->
<template>
	<div>
		<video
			ref="videoPlayer"
			class="video-js"
		/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import videojs from "video.js";
import "video.js/dist/video-js.css";

type ComponentData = { player: any };

export default defineComponent({
	name: "VideojsPlayer",
	props: {
		options: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	data: (): ComponentData => ({ player: null }),
	mounted() {
		// @ts-ignore FIXME: need to figure out how to set the `videoPlayer` ref
		this.player = videojs(this.$refs.videoPlayer, this.options, () => {
			// this.player.log("onPlayerReady", this);
		});
	},
	beforeUnmount() {
		if (this.player) {
			this.player.dispose();
		}
	},
});
</script>
